import { render } from "./IconTurnSharpRight.vue?vue&type=template&id=63dadf01"
import script from "./IconTurnSharpRight.vue?vue&type=script&lang=js"
export * from "./IconTurnSharpRight.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__